import { statusSituation } from '../helpers/enum';

export default (history, item) => {
  if(item.estado) {
    return history.push('/admin/cdt-detail', item)
  }

  if(!item.estado) {
    console.log(item);
    return history.push('/admin/dashboard');
  }
}
